import { useSelector } from "react-redux";
import Table from "./components/dashboard/table";

function DashTable() {
  
  const submissions = useSelector(
    (state) => state.form.submissions
  );
  // console.log("Redux submissions:", submissions);
  return <Table data={submissions} />;
}

export default DashTable;